import React, { useEffect, useState } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
 
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

//N, T, D, k_off
const RbVSKonGraph = React.memo(function (props) {
  const [options, setOptions] = useState({});
  useEffect(() => {
    // Your data generation logic here
    const N = props.N;
    const T = props.T;
    const D = props.D;
    const k_off = props.k_off;

    // Define a range of k_on values
    const k_on_values = [];
    for (let i = -3; i <= 20; i += 0.0001) {
      k_on_values.push(Math.pow(10, i));
    }

    // Calculate rb for the specified k_off value
    const rb_values = k_on_values.map((k_on) =>
      (k_on * N) / (k_off + k_on * T) * Math.sqrt(k_off / D)
    );

    // Prepare data points
    const dataPoints = k_on_values.map((k_on, index) => ({
      x: Math.log10(k_on),
      y: Math.log10(rb_values[index]),
    }));

    const options = {
      axisX: {
        title: 'log(k_on)',
      },
      axisY: {
        title: 'log(rb)',
      },
      data: [
        {
          type: 'line',
          dataPoints: dataPoints,
        },
      ],
    };

    setOptions(options);
  }, [props.N, props.T, props.D, props.k_off]);

  return (
    <div className="interactive-graph">
      <CanvasJSChart options={options} />
    </div>
  );
})

export default RbVSKonGraph;
